import { ConfigProvider } from 'antd-mobile';
import React from 'react';
import { Provider } from 'react-redux';
import { Toaster } from 'sonner';

import { store } from './app/store';
import AppRouter from './routes';
import './locales/i18n';
import './App.css';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <ConfigProvider>
        <AppRouter />
        <Toaster position="top-center" richColors />
      </ConfigProvider>
    </Provider>
  );
};

export default App;
